/* @flow */
import cx from 'classnames';
import * as React from 'react';
import filesize from 'filesize';
import Link from 'components/Link';
import Video from 'components/Video';
import Audio from 'components/Audio';
import Glyph from 'components/Glyph';
import Image from 'components/Image';
import { getGlyphName } from 'lib/FileTypes';
import MessageItemImageAttachment from './MessageItemImageAttachment';

import './styles/MessageItemAttachment.scss';

type Props = {
  file: FileGQL,
};

type State = {
  hover: boolean,
};

class MessageItemAttachment extends React.Component<Props, State> {
  state = {
    hover: false,
  };

  hoverOn = () => this.setState({ hover: true });
  hoverOff = () => this.setState({ hover: false });

  renderAudioPreview(file: FileGQL) {
    return (
      <div className="MessageItemAttachment-multimedia">
        <Audio src={file.url} key={file.uuid} />
      </div>
    );
  }

  renderImagePreview(file: FileGQL) {
    return (
      <div className="MessageItemAttachment-multimedia">
        <MessageItemImageAttachment file={file} />
      </div>
    );
  }

  renderVideoPreview(file: FileGQL) {
    return (
      <div className="MessageItemAttachment-multimedia MessageItemAttachment-video">
        <Video src={file.url} key={file.uuid} />
      </div>
    );
  }

  render() {
    const { file } = this.props;
    const { contentType, url } = file;

    if (Image.isSupportedType(contentType)) {
      return this.renderImagePreview(file);
    } else if (Audio.isSupportedType(contentType)) {
      return this.renderAudioPreview(file);
    } else if (Video.isSupportedType(contentType)) {
      return this.renderVideoPreview(file);
    }

    let { size } = file;

    if (size) {
      size = filesize(size, { round: 0 }).toUpperCase();
    }

    const glyphName = this.state.hover ? 'download' : getGlyphName(contentType);

    return (
      <div className="MessageItemAttachment">
        <Link
          href={url}
          target="_blank"
          onMouseEnter={this.hoverOn}
          onMouseLeave={this.hoverOff}
          className="MessageItemAttachment-icon"
          eventElementName="MessageItemAttachment-icon">
          <Glyph name={glyphName} size="xlarge" solo />
        </Link>
        <div
          className={cx({
            'MessageItemAttachment-info': true,
            hovered: this.state.hover,
          })}>
          <Link
            href={url}
            target="_blank"
            className="MessageItemAttachment-name"
            eventElementName="MessageItemAttachment-name">
            {file.name}
          </Link>
          <div className="MessageItemAttachment-metadata">
            <em>{size}</em>
          </div>
        </div>
      </div>
    );
  }
}

export default MessageItemAttachment;
